export default __webpack_public_path__ + "static/nathan-bitmoji-baa352503c1847df3ea8458ab00de969.png";